<template>
  <div>
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <a-divider orientation="left">
        Contact
      </a-divider>
      <a-row :gutter="10" class="ContactInfo">
        <!-- Last Name -->
        <a-col :xs="24" :lg="5">
          <a-form-item
            label="Last Name"
          >
            <a-input
              v-decorator="[
                'lastName',
                {rules: [{ required: false, message: 'Please input your last name!' }]}
              ]"
              placeholder="Please input your last name"
            />
          </a-form-item>
        </a-col>
        <!-- First Name -->
        <a-col :xs="24" :lg="5">
          <a-form-item
            label="First Name"
          >
            <a-input
              v-decorator="[
                'firstName',
                {rules: [{ required: false, message: 'Please input your first name!' }]}
              ]"
              placeholder="Please input your first name"
            />
          </a-form-item>
        </a-col>
        <!-- Middle Name -->
        <a-col :xs="24" :lg="4">
          <a-form-item
            label="Middle Name"
          >
            <a-input
              v-decorator="[
                'middleName',
                {rules: [{ required: false, message: 'Please input your middle name!' }]}
              ]"
              placeholder="Please input your middle name"
            />
          </a-form-item>
        </a-col>
        <!-- Post -->
        <a-col :xs="24" :lg="3">
          <a-form-item
            label="Post"
          >
            <a-select
              v-decorator="[
                'post',
                {rules: [{ required: false, message: 'Please select your post!' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option value="">All</a-select-option>
              <a-select-option value="Sales">Sales</a-select-option>
              <a-select-option value="OP">OP</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- Email -->
        <a-col :xs="24" :lg="6">
          <a-form-item
            label="Email"
          >
            <a-input
              v-decorator="[
                'email',
                {rules: [{ required: false, message: 'Please input your email!' }]}
              ]"
              placeholder="Please input your email"
            />
          </a-form-item>
          </a-col>
      </a-row>
      <!-- Contact number -->
      <a-row :gutter="10" class="ContactInfo" style="display:flex;padding-right: 0;">
        <a-col :xs="24" :lg="7" style="padding-right: 0;">
          <a-form-item
            label="Contact number"
          >
            <PhonenumberInput :initData="{ countryCode: 'US', countryCallingCode: '1', isValid: false, phoneNumber: '' }"/>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="2" class="phone-number-extension">
          <a-form-item label=" ">
            <a-input
              v-decorator="[
                'phoneExt',
                {rules: [{ required: false, message: 'Please input your ext!' }]}
              ]"
              class="phone-number-extension-input"
              placeholder="Ext."
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider dashed />
      <a-form-item
        label="Whether to Provide"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-checkbox-group
          :options="plainOptions"
        />
      </a-form-item>
      <!-- 房型设定 -->
      <a-form-item
        :labelCol="labelCol"
        label="Other Rooms"
        :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 18 }
        }"
      >
        <a-button type="dashed" style="width: 60%" @click="handleOtherRoomAdd"> <a-icon type="plus" /> Add </a-button>
      </a-form-item>
      <a-divider orientation="left">
        Story
      </a-divider>
      <!-- Hotel style or character -->
      <a-form-item
        label="Hotel style or character"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          auto-size
        />
      </a-form-item>
      <!-- Selection process and reason -->
      <a-form-item
        label="Selection and Reason"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          auto-size
        />
      </a-form-item>
      <!-- Nearby attractions -->
      <a-form-item
        :labelCol="labelCol"
        label="Nearby Attractions"
      >
        <ma-editor>
        </ma-editor>
      </a-form-item>
      <a-divider orientation="left">
        Important Consulting
      </a-divider>
      <!-- Brand/Group -->
      <a-form-item
        label="Brand/Group"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          auto-size
        />
      </a-form-item>
      <!-- Building Year -->
      <a-form-item
        label="Building Year"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-date-picker
          style="width: 100%;"
          format="MM/DD/YYYY"
        />
      </a-form-item>
      <!-- Last decoration time -->
      <a-form-item
        label="Last Decoration Time"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-date-picker
          style="width: 100%;"
          format="MM/DD/YYYY"
        />
      </a-form-item>
      <!-- total number of rooms -->
      <a-form-item
        label="Total number of rooms"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input-number id="inputNumber" />
      </a-form-item>
    </a-form>
    <div>
      <other-room
        :otherRoomNum="otherRoomBookNum" 
        @cancel="() => { this.otherRoomBookNum = null }"
        @confirm="() => { this.otherRoomBookNum = null }"
      />
    </div>
  </div>
</template>

<script>
import OtherRoom from './HotelOtherRoom'
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'
import MaEditor from '@/components/ma/MaTinyMCE'

export default {
  name: 'HotelDesigner',
  components: {
    PhonenumberInput,
    MaEditor,
    OtherRoom
  },
  props: {
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      phoneNumberData: null,
      otherRoomBookNum: null,
      plainOptions: ['TG Room', 'DR Room']
    }
  },
  mounted () {
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
    },
    handleOtherRoomAdd () {
      this.otherRoomBookNum = 'true'
    }
  }
}
</script>
<style lang="less" scoped>
.ant-btn-dashed {
  background: #fff;
}
.phone-number-extension {
  padding-left: 0 !important;
  margin-left: -3px;
}
.phone-number-extension-input {
  height: 40px;
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}
.phone-number-extension ::v-deep .ant-form-item-label > label::after {
  content: '';
}
.ContactInfo .ant-form-item, .ContactInfo {
  margin-bottom: 0;
}
.roomBox {
  color: #333;
  padding-right: 10px;
}
</style>